module.exports = require('lodash');



//////////////////
// WEBPACK FOOTER
// ./~/ES/lib/lodash.js
// module id = 1
// module chunks = 0 1 2 3 4